import type {
  TrackerProvider,
  TrackEvent,
  TrackContextPayload,
} from '../types';
import { isMetaTrackingEnabled } from '../meta-event';

const STANDARD_EVENTS = new Set<string>([
  'PageView',
  'Lead',
  'CompleteRegistration',
  'InitiateCheckout',
  'Purchase',
  'ViewContent',
  'Search',
  'AddToCart',
  'AddToWishlist',
  'Schedule',
  'StartTrial',
  'SubmitApplication',
  'Contact',
  'Donate',
  'FindLocation',
  'CustomizeProduct',
]);

const DESCRIPTION_TO_META: Record<string, string> = {
  pageView: 'PageView',
  submitApplication: 'SubmitApplication',
  signUp: 'Lead',
  completeRegistration: 'CompleteRegistration',
  purchase: 'Purchase',
  initiateCheckout: 'InitiateCheckout',
  viewContent: 'ViewContent',
  search: 'Search',
};

function fireMetaEvent(metaEvent: string, payload?: TrackContextPayload) {
  if (!window.fbq || !window.fbqPixelInitialized) return;

  const eventId =
    typeof payload?.event_id === 'string' ? payload.event_id : undefined;
  const eventData = { ...(payload ?? {}) };
  delete eventData.event_id;

  if (STANDARD_EVENTS.has(metaEvent)) {
    if (eventId) {
      window.fbq('track', metaEvent, eventData, { eventID: eventId });
    } else {
      window.fbq('track', metaEvent, eventData);
    }
    return;
  }

  if (eventId) {
    window.fbq('trackCustom', metaEvent, eventData, { eventID: eventId });
  } else {
    window.fbq('trackCustom', metaEvent, eventData);
  }
}

export const metaPixelProvider: TrackerProvider = {
  name: 'metaPixel',
  track: (event: TrackEvent) => {
    if (!isMetaTrackingEnabled()) return;
    const metaEvent = DESCRIPTION_TO_META[event.eventDescription];
    if (!metaEvent) return;
    fireMetaEvent(metaEvent, event.payload);
  },
};
